import { render, staticRenderFns } from "./BottomSheetMenu.vue?vue&type=template&id=88ca09d4&scoped=true"
import script from "./BottomSheetMenu.vue?vue&type=script&lang=js"
export * from "./BottomSheetMenu.vue?vue&type=script&lang=js"
import style0 from "./BottomSheetMenu.vue?vue&type=style&index=0&id=88ca09d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ca09d4",
  null
  
)

export default component.exports